import { Injectable } from '@angular/core';
import * as html2pdf from 'html2pdf.js';


@Injectable({
    providedIn: 'root'
})
export class PdfService {

    constructor() { }

    /**
     * Generates a PDF from an HTML element
     * @param elementId The ID of the HTML element to capture
     * @param fileName The name of the generated PDF file
     * @returns A promise that resolves when the PDF is generated and saved
     */
    generatePdf(elementId: string, fileName: string): any {
        const element = document.getElementById(elementId);
        if (!element) {
            console.error(`Element with id ${elementId} not found`);
            return Promise.reject('Element not found');
        }

        const opt = {
            margin: [10, 10, 10, 10],
            filename: `${fileName}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true, letterRendering: true },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
        };

        // Return the Promise from html2pdf
        return html2pdf().from(element).set(opt).save();
    }
}
